export class NewBlank {
  public number: string;
  public name: string;
  public formData: FormData;

  constructor(number: string, name: string, formData: FormData) {
    this.number = number;
    this.name = name;
    this.formData = formData;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/new-blank.model.ts